<template>
  <div class="pay_result">
    <div class="pay_box">
    <div class="store_wrap" >
          <img class="store_img"  src="../../images/testimg.png"  />
          <div class="store_name">某某商铺</div>
      </div>
      <div class="order_result">
        <div class="order_item">
          <div class="item_l">订单状态</div>
          <div>支付{{type == 1?'成功':'失败'}}</div>
        </div>
        <div class="order_item" v-if="type == 1">
          <div class="item_l">订单尾号</div>
          <div>2073</div>
        </div><div class="order_item" v-if="type == 1">
          <div class="item_l">支付金额</div>
          <div style="font-weight:bold">￥15.00</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>



export default {
  name: "payResult",
  controller: "UI",
  action: "payResult",
  props: {
    query: {
    }
  },
  data: function() {
    return {
      type:1
    };
  },
  created() {
     
  },
  methods: {
  },
  computed: {
   
  }
};
</script>
<style  scoped>
.pay_box{
  background-color: #fff;
  padding: 0.4rem;
}
.store_wrap{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 0.4rem;
}
.store_img{
  width: 0.6rem;
  height: 0.6rem;
  display: inline-block;
  margin-right: 0.15rem;
  border-radius: 50%;
}

.store_name{
  font-size: 0.3rem;
  color: #333;
}
.order_item{
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.3rem;
  margin-bottom: 0.4rem;
  color: #333;
}
.item_l{
  color: #8c8c8c;
}
</style>